import type { CrudConfig } from '@/components/GenericCrudPage';

export const productsConfig: CrudConfig = {
  resource: 'products',
  title: '产品目录',
  rowKey: 'id',
  searchFields: ['product_type', 'industry', 'is_active'],
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    { name: 'code', label: '产品代码', type: 'text', required: true, copyable: true, width: 160 },
    { name: 'display_name', label: '名称', type: 'readonly', ellipsis: true, hideInForm: true, readonly: true },
    {
      name: 'product_type',
      label: '产品类型',
      type: 'select',
      required: true,
      width: 120,
      options: [
        { label: '订阅', value: 'SUBSCRIPTION', color: 'blue' },
        { label: '模拟题', value: 'MOCK_EXAM', color: 'cyan' },
        { label: '正式考试', value: 'EXAM', color: 'purple' },
        { label: '课程', value: 'COURSE', color: 'gold' },
        { label: '证书', value: 'CERTIFICATE', color: 'green' },
      ],
    },
    { name: 'industry', label: '行业 ID', type: 'number', width: 100 },
    { name: 'price', label: '价格', type: 'number', required: true, width: 120, hideInSearch: true },
    { name: 'currency', label: '币种', type: 'text', width: 80, placeholder: 'CNY/USD' },
    { name: 'duration_days', label: '有效期(天)', type: 'number', width: 110, hideInSearch: true },
    { name: 'is_active', label: '上架', type: 'boolean', width: 100 },
    { name: 'sort', label: '排序', type: 'number', width: 80, hideInSearch: true, hideInTable: true },
  ],
};
